import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3f29fe4c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "menu-left"
};
var _hoisted_2 = {
  id: "btn-upload-hd",
  title: "upload HD"
};
var _hoisted_3 = {
  class: "postion-relative"
};
var _hoisted_4 = {
  key: 0,
  class: "switch_container"
};
var _hoisted_5 = {
  class: "label"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Dernier", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "separator"
  }, null, -1);
});

var _hoisted_8 = {
  class: "label"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Initial", -1);
});

var _hoisted_10 = {
  id: "btn-select-floor",
  title: "select floor"
};
var _hoisted_11 = {
  id: "btn-select-wall",
  title: "select wall"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$isCompare, _ctx$isCompare2;

  var _component_UploadSVG = _resolveComponent("UploadSVG");

  var _component_CompareSVG = _resolveComponent("CompareSVG");

  var _component_el_button = _resolveComponent("el-button");

  var _component_FloorSVG = _resolveComponent("FloorSVG");

  var _component_WallSVG = _resolveComponent("WallSVG");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", null, [_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.openModalEspace && _ctx.openModalEspace.apply(_ctx, arguments);
    }),
    class: "rounded-top"
  }, [_createElementVNode("a", _hoisted_2, [_createVNode(_component_UploadSVG, {
    fill: _ctx.color,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", _hoisted_3, [_createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleCompare({
        toggle: true
      });
    }),
    id: "btn-split-view",
    title: "Split view to compare products"
  }, [_createVNode(_component_CompareSVG, {
    fill: _ctx.color,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])]), _ctx.isCompare.active ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.handleCompare({
        mode: 'LAST'
      });
    }),
    type: "primary",
    size: "small",
    plain: !(((_ctx$isCompare = _ctx.isCompare) === null || _ctx$isCompare === void 0 ? void 0 : _ctx$isCompare.mode) == 'LAST')
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }, 8, ["plain"])]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.handleCompare({
        mode: 'INITIAL'
      });
    }),
    type: "primary",
    size: "small",
    plain: !(((_ctx$isCompare2 = _ctx.isCompare) === null || _ctx$isCompare2 === void 0 ? void 0 : _ctx$isCompare2.mode) == 'INITIAL')
  }, {
    default: _withCtx(function () {
      return [_hoisted_9];
    }),
    _: 1
  }, 8, ["plain"])])])) : _createCommentVNode("", true)]), _createElementVNode("li", {
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    function () {
      return _ctx.openModalFloor && _ctx.openModalFloor.apply(_ctx, arguments);
    })
  }, [_createElementVNode("a", _hoisted_10, [_createVNode(_component_FloorSVG, {
    fill: _ctx.color,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", {
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    function () {
      return _ctx.openModalWall && _ctx.openModalWall.apply(_ctx, arguments);
    }),
    class: "rounded-bottom"
  }, [_createElementVNode("a", _hoisted_11, [_createVNode(_component_WallSVG, {
    fill: _ctx.color,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])])])]);
}